/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rd_Check_CiInputs */

const en_rd_check_ci = /** @type {(inputs: Rd_Check_CiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CI workflow`)
};

const id_rd_check_ci = /** @type {(inputs: Rd_Check_CiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workflow CI`)
};

/**
* | output |
* | --- |
* | "CI workflow" |
*
* @param {Rd_Check_CiInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_check_ci = /** @type {((inputs?: Rd_Check_CiInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_Check_CiInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_check_ci(inputs)
	return en_rd_check_ci(inputs)
});